<template>
    <div>
        <div class="form-group">
            <label for="nombre">Número de contenedores</label>
            <input type="number" class="general-input mt-1" v-model = form.containerNumber placeholder="Número de contenedores">
        </div>
        <div class="form-group">
            <label for="size">Tamaño de contenedores</label>
            <!-- <input type="text" class="general-input mt-1"  v-model = form.containerSize placeholder="40 pies"> -->
            <select class="select-input mt-1 "  v-model = form.containerSize >
                <option value="S40FT " selected>40 pies</option>
                <option value="S20FT">20 pies</option>
            </select>
        </div>
        <div class="form-group">
            <label for="size">Tipo de mercancia</label>
            <input type="text" class="general-input mt-1" v-model = form.merchandiseType placeholder="Tipo de mercancia">
        </div>
        <div class="form-group">
            <label for="size">Peso</label>
            <input type="number" class="general-input mt-1" v-model = form.weight placeholder="15.000 Kg">
        </div>
        <div class="form-group">
            <label for="destination">Destino</label>
            <input type="text" class="general-input mt-1" v-model = form.destination placeholder="Destino">
        </div>
        <div class="form-group row">
            <label for="mercanciaPeligrosa" class="col-auto col-form-label">Mercancia peligrosa</label>
            <div class="ml-auto col-1 pt-2">
                <input class="form-check-input position-static" type="checkbox"   v-model = form.dangerousMerchandise>
            </div>
        </div>
        <!-- <div class="form-group row">
            <label for="mercanciaPeligrosa" class="col-auto col-form-label">Mercancia refrigerada</label>
            <div class="ml-auto col-1 pt-1">
                <input class="form-check-input position-static" type="checkbox" disabled  v-model = form.cooledMerchandise>
            </div>
        </div> -->
        <!-- <div class="form-group mt-5">
            <label for="matricula">Matrícula contenedor (Asignado por armador)</label>
            <input type="text" class="general-input mt-1" placeholder="Matrícula de contenedor">
        </div>
         <div class="form-group ">
            <label for="matricula">Armador</label>
            <select class="select-input mt-1 ">
                <option selected>Maersk</option>
                <option>Armador 2</option>
                <option>Armador 3</option>
            </select>
        </div> -->
        <div class="form-group mt-4">
            <button type="button" @click="nextPart()" :disabled = "!completedPart1" class="btn-general">
                Siguiente
            </button>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'createNewPart1',
  data() {
    return {
        form: {
            containerNumber: '',
            containerSize: 'S20FT',
            merchandiseType: '',
            weight: '',
            destination: '',
            dangerousMerchandise: false,
            // cooledMerchandise: false
        }
    }
  },
  computed: { 
      completedPart1: function () {
        if(this.form.containerNumber && this.form.containerSize && this.form.merchandiseType && this.form.weight && this.form.destination){
          return true
        }else {
          return false
        }
      }
  },
  mounted () {
   
  },
  methods: { 
      nextPart(){
          this.$parent.part1completed = true
          this.$parent.title = 'Reserva 2/2'
          this.$store.commit('container/set_reservation_data', this.form)
      }
  }
}
</script>

<style lang= "scss"  scoped>


</style>
